import * as rules from "LIB/validation/rules";
import {
  COMPANY,
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS,
  DROPSHIP
} from "MODULES/PurchaseOrders/constants";
import {
  INSPECTED,
  OVERHAULED,
  REPAIRED
} from "MODULES/IncomingQuotes/constants";
import { TAG_DATE, TAGGED_BY } from "MODULES/inventories/constants";
import {
  CARRIER,
  CITY,
  COUNTRY,
  LINE1,
  POSTAL_CODE,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIPPING_ADDRESS,
  SHIPPING_METHOD,
  SHIPPING_TYPE
} from "APP_ROOT/constants";
import { REPAIR_STATION } from "MODULES/companies/constants";

export function validateConditionFields(values, form) {
  if ([OVERHAULED, INSPECTED, REPAIRED].includes(values.condition)) {
    form.validate(TAG_DATE).required();
  }

  if ([OVERHAULED, INSPECTED, REPAIRED].includes(values.condition)) {
    form.validate(TAGGED_BY).required();
  }
}

export function validatePurchaseForFields(values, form) {
  form.validate("_error").satisfies(() => {
    if (
      !(
        values.purchase_for_repair_assist ||
        values.purchase_for_repair ||
        values.purchase_for_sale ||
        values.purchase_for_stock
      )
    ) {
      return "At least 1 Purchase For selection is required";
    }

    return null;
  });
}

export function validatePurchaseForSaleFields(values, form) {
  if (values.purchase_for_sale) {
    form
      .validate("reserve_for_seller_id", "reserve_for_sale_quantity")
      .required();
    form
      .validate("reserve_for_sale_quantity")
      .satisfies(rules.isGreaterThan(0));

    if (values.quantity) {
      form
        .validate("reserve_for_sale_quantity")
        .satisfies(rules.isLessThanOrEqualTo(values.quantity));
    }
  }
}

export function validateShippingFields(values, form) {
  form.validate(SHIPPING_TYPE).satisfies(rules.required);

  if (values.shipping_type === COMPANY) {
    form.validate(SHIP_TO_COMPANY_ID, SHIP_TO_COMPANY_ADDRESS_ID).required();
  }

  if (values.shipping_type === DROPSHIP) {
    form.validateChild(SHIPPING_ADDRESS, a => {
      a.validate(LINE1, CITY, POSTAL_CODE, COUNTRY).required();
    });
  }

  if (values.shipping_type === REPAIR_STATION) {
    form.validate("repair_station_physical_address_id").required();
  }

  if (values.shipping_type === DO_NOT_SHIP) {
    form.validate("_error").satisfies(() => {
      if (!DO_NOT_SHIP_REASONS.some(field => values[field])) {
        return "At least 1 DO NOT SHIP REASON selection is required";
      }

      return null;
    });
  } else {
    form.validateChild(SHIPPING_METHOD, s => {
      s.validate(CARRIER, SHIPPING_METHOD).satisfies(rules.required);
    });
  }
}



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/validations.js